import Api from "../singleton/api";
import IRollupReturnData from "../interface/rollup-return-data";
import IApiRollupData from "../interface/api/api-rollup-data";
import IApiRollup from "../interface/api/api-rollup";
import Global from "../global";

const RollupCacheExpiration = Global.ROLLUP_CACHE_EXPIRATION;

export default class RollupCacheItem {

    public rollup: IApiRollup;

    private value: IApiRollupData[] | undefined = [];

    private promise: Promise<IApiRollupData[]> | undefined;

    private timestamp: number = 0;

    constructor(rollup: IApiRollup) {
        this.rollup = rollup;
    }

    public async getData(): Promise<IRollupReturnData> {
        const time: number = (new Date()).getTime();
        if (this.value && this.value.length && time - this.timestamp < RollupCacheExpiration) {
            return this.getReturnData();
        } else {
            if (this.promise) {
                await this.promise;
            } else {
                try {
                    this.promise = Api.rollupGetData(this.rollup);
                    this.value = await this.promise;
                    this.promise = undefined;
                    this.timestamp = (new Date()).getTime();
                } catch (e) {
                    this.value = [];
                    this.promise = undefined;
                }
            }
            return this.getReturnData();
        }
    }

    private getReturnData(): IRollupReturnData {
        return {
            data: this.value || [],
            fieldValueId: this.rollup.rolFCN,
            fieldLabelId: this.rollup.rolGroups[0] || null
        };
    }

}

